/* Send us your artwork.

   The twin of the mock-up request, and deliberately the same object on screen:
   same frame, same build summary, same drop zone. What differs is where it
   goes and what happens afterwards.

   It posts to Shopify's own contact form, which reaches the address on the
   shop record — sales@megaprintery.com — so the artwork is in the studio's
   inbox the moment the buyer presses send, whether or not they go on to pay.
   Shopify will not carry an attachment through that form, so each file goes
   to the shop's own files first, briefly as a cart line that is removed again
   the moment the URL comes back, and the message carries the links.

   Afterwards the files are pushed into the build sheet's own file input, so a
   buyer who then adds the stand to the cart has the artwork travelling with
   the order as well. mp-buy.js is untouched: it finds the file exactly where
   it has always looked for it.

   Shopify's ceiling is 20 MB a file and it says so with a bare 413. Rather
   than put a number in front of a buyer, an oversize file is kept in the
   list, flagged quietly, and named in the enquiry so somebody can send an
   upload link for it. The send still goes.

   One thing had to be learned the hard way, twice.

   Shopify puts hCaptcha in front of POST /contact. Its script binds by
   looking for form[action*='/contact'] and listening for a submit event on
   the document, which means two things have to be true or the post arrives
   with no token and Shopify answers "Missing CAPTCHA token": the panel has to
   be a real form with that action, and the browser has to raise a real submit
   event. A fetch raises none. form.submit() raises none either — that is the
   method, not the event — so the fallback was as silent as the thing it was
   falling back from.

   So nothing here posts any more. The files are lodged first, because that
   part is ours and it is asynchronous; then the handler stands aside and lets
   the browser submit the form it is attached to, and Shopify's own script
   puts the token on it on the way out. The sheet is put back the way the
   buyer left it when the page returns. */
(function () {
  "use strict";

  var CEILING = 20 * 1024 * 1024;   /* Shopify's own, not ours. Never shown. */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return "$" + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function size(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(bytes >= 10485760 ? 0 : 1) + " MB";
    return Math.max(1, Math.round(bytes / 1024)) + " KB";
  }
  function shortName(o) {
    var t = ((o && o.textContent) || "").replace(/\s+/g, " ").trim();
    var cut = t.indexOf("·");
    if (cut > 0) t = t.slice(0, cut);
    return t.trim() || ((o && o.dataset && o.dataset.name) || "").trim();
  }

  /* The sheet, read straight off the page at the moment of sending. */
  function readBuild(root) {
    var form   = $(".mps-buyform", root);
    var sel    = $("[data-variant-select]", root);
    var qtyIn  = $("[data-qty]", root);
    var dateIn = $("[data-show-date]", root);
    var o      = (sel && sel.options.length) ? sel.options[sel.selectedIndex] : null;

    /* A companion row can hold several answers with a count against each
       one, which is more than a select can say. mp-pick.js keeps the list
       in a hidden field beside it; the select is only read when that field
       is not there. */
    var chosen = [], extra = 0;
    $$("[data-addon]", root).forEach(function (s) {
      var carrier = s.parentNode ? s.parentNode.querySelector("[data-addon-cart]") : null;
      if (carrier) {
        var list = [];
        try { list = JSON.parse(carrier.value || "[]") || []; } catch (e) { list = []; }
        list.forEach(function (it) {
          var q = parseInt(it && it.q, 10) || 0;
          if (!it || !it.id || q < 1) return;
          var nm = String(it.n || "").trim();
          chosen.push(q > 1 ? (nm + " \u00d7 " + q) : nm);
          extra += (parseInt(it.c, 10) || 0) * q;
        });
        return;
      }
      var a = s.options[s.selectedIndex];
      if (a && a.value) {
        chosen.push(((a.dataset.name || "").trim()) || shortName(a));
        extra += parseInt(a.dataset.price, 10) || 0;
      }
    });

    var base = o && o.dataset.cents
      ? (parseInt(o.dataset.cents, 10) || 0)
      : (parseInt(form && form.dataset.basePrice, 10) || 0);
    var n = Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1);
    var unit = base + extra;

    return {
      stand:  (form && form.dataset.productName) || "",
      build:  (o && ((o.dataset.label || "").trim() || shortName(o))) || "",
      sku:    (o && o.dataset.sku) || "",
      addons: chosen,
      qty:    n,
      date:   (dateIn && dateIn.value) || "",
      unit:   money(unit),
      total:  money(unit * n)
    };
  }

  function fillBuild(dlg, b) {
    var rows = $("[data-asum-rows]", dlg);
    var sku  = $("[data-asum-sku]", dlg);
    if (sku) sku.textContent = b.sku || "";

    var out = [];
    function row(k, v, cls) {
      out.push('<div class="mpq-row' + (cls ? " " + cls : "") + '"><i>' +
               esc(k) + "</i><span>" + esc(v) + "</span></div>");
    }
    if (b.stand) row("Stand", b.stand);
    if (b.build) row("Build", b.build);
    if (b.addons.length) row("Added with it", b.addons.join(", "));
    if (b.qty > 1) row("Quantity", b.qty);
    if (b.date) row("Show date", b.date);
    row("Total", b.qty > 1 ? (b.unit + " each · " + b.total) : b.total, "tot");
    if (rows) rows.innerHTML = out.join("");

    function put(q, v) { var el = $(q, dlg); if (el) el.value = v; }
    put("[data-asum-build]",  b.build);
    put("[data-asum-skuin]",  b.sku);
    put("[data-asum-addons]", b.addons.join(", ") || "None");
    put("[data-asum-qty]",    String(b.qty));
    put("[data-asum-total]",  b.qty > 1
      ? (b.unit + " each, " + b.total + " for " + b.qty)
      : b.total);
  }

  /* Each file to the shop's own files, so the message can carry a link. */
  function uploadViaCart(variantId, file) {
    var fd = new FormData();
    fd.append("id", variantId);
    fd.append("quantity", "1");
    fd.append("properties[_mp_artwork_file]", file, file.name);
    return fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { Accept: "application/json" }, body: fd
    }).then(function (r) {
      if (!r.ok) throw new Error("upload");
      return r.json();
    }).then(function (data) {
      var item = (data.items && data.items[0]) || data;
      var url  = (item.properties || {})._mp_artwork_file || "";
      var key  = item.key;
      if (!key) return url;
      return fetch("/cart/change.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { return url; });
    });
  }

  /* So the stand carries the artwork to the order as well. mp-buy.js reads
     the sheet's own file input and knows nothing about this dialog. */
  function handToSheet(root, files) {
    var sheetIn = $("[data-artwork]", root);
    if (!sheetIn || !files.length || typeof DataTransfer === "undefined") return false;
    try {
      var dt = new DataTransfer();
      dt.items.add(files[0]);
      sheetIn.files = dt.files;
      return true;
    } catch (e) { return false; }
  }

  function markSent(root, email, n, onOrder) {
    var lb   = $("[data-artwork-label]", root);
    var btn  = $("[data-artwork-open]", root);
    var note = $("[data-artwork-note]", root);
    if (lb) lb.textContent = n > 1 ? (n + " files sent") : "Artwork sent";
    if (btn) btn.classList.add("is-done");
    if (note) {
      note.textContent = "With our studio" + (email ? ", and a copy to " + email : "") + ". "
        + (onOrder
            ? "It travels with the order too. Open this again to send more."
            : "Open this again to send more.");
    }
  }


  /* --------------------------------------------------------- delivery -- */
  /* Everything that has to survive a page load if the challenge sends us
     the long way round. */
  var STASH = "mp_artsend_pending";

  function sheetState(root) {
    var sel   = $("[data-variant-select]", root);
    var qtyIn = $("[data-qty]", root);
    var dIn   = $("[data-show-date]", root);
    var picks = [];
    $$("[data-addon]", root).forEach(function (s, i) {
      picks.push([i, s.value || ""]);
    });
    return {
      path: window.location.pathname,
      variant: sel ? sel.value : "",
      qty: qtyIn ? qtyIn.value : "",
      date: dIn ? dIn.value : "",
      addons: picks
    };
  }

  function restoreSheet(root, st) {
    var sel   = $("[data-variant-select]", root);
    var qtyIn = $("[data-qty]", root);
    var dIn   = $("[data-show-date]", root);
    if (sel && st.variant) { sel.value = st.variant; }
    if (qtyIn && st.qty) { qtyIn.value = st.qty; }
    if (dIn && st.date) { dIn.value = st.date; }
    var sels = $$("[data-addon]", root);
    (st.addons || []).forEach(function (pair) {
      var s = sels[pair[0]];
      if (s && pair[1]) s.value = pair[1];
    });
    /* mp-buy.js repaints the total off these events and nothing else. */
    if (sel) sel.dispatchEvent(new Event("change", { bubbles: true }));
    sels.forEach(function (s) { s.dispatchEvent(new Event("change", { bubbles: true })); });
    if (qtyIn) qtyIn.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function wire() {
    var root = $("[data-product-root]") || document;
    var dlg  = $("[data-art-dialog]", root);
    if (!dlg || dlg.dataset.mpa) return;
    dlg.dataset.mpa = "1";

    var aform    = $("[data-art-form]", dlg);
    var fileIn   = $("[data-art-file]", dlg);
    var drop     = $("[data-art-drop]", dlg);
    var listEl   = $("[data-art-files]", dlg);
    var bigBox   = $("[data-art-big]", dlg);
    var urlIn    = $("[data-art-fileurl]", dlg);
    var bigIn    = $("[data-art-bigin]", dlg);
    var errBox   = $("[data-art-err]", dlg);
    var live     = $("[data-art-live]", dlg);
    var done     = $("[data-art-done]", dlg);
    var doneLine = $("[data-art-doneline]", dlg);
    var foot     = $("[data-art-foot]", dlg);
    var send     = $("[data-art-send]", dlg);
    var openBtn  = $("[data-artwork-open]", root);
    var dateIn   = $("[data-show-date]", root);
    if (!aform) return;

    /* Everything chosen so far, across however many trips to the picker and
       however many drops. Choosing again adds to the pile rather than
       replacing it, which is what a file input does left alone. */
    var picked = [];

    /* The panel scrolls and the footer is pinned to the bottom of it, so the
       line saying what was wrong was written under the fold, behind the
       button. Pressing Send with an empty name moved the cursor and nothing
       else, which reads as a dead button. It is said here instead, on a strip
       directly above the button, which never scrolls away. */
    var strip = document.createElement("p");
    strip.className = "mpq-status";
    strip.setAttribute("role", "status");
    strip.setAttribute("aria-live", "polite");
    strip.hidden = true;
    if (foot && foot.parentNode) foot.parentNode.insertBefore(strip, foot);

    function say(kind, msg) {
      if (!msg) {
        strip.hidden = true;
        strip.textContent = "";
        strip.removeAttribute("data-kind");
        return;
      }
      strip.textContent = msg;
      strip.setAttribute("data-kind", kind);
      strip.hidden = false;
    }

    function flag(el) {
      if (!el) return;
      el.classList.add("is-bad");
      if (el.scrollIntoView) el.scrollIntoView({ block: "center" });
      try { el.focus(); } catch (e) {}
      el.addEventListener("input", function clear() {
        el.classList.remove("is-bad");
        say("", "");
        el.removeEventListener("input", clear);
      });
    }

    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute("open"); }
    $$("[data-art-close]", dlg).forEach(function (b) { b.addEventListener("click", close); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) close(); });

    if (openBtn) {
      openBtn.addEventListener("click", function () {
        /* A second trip starts from the form again, not from the receipt. */
        if (live) live.hidden = false;
        if (foot) foot.hidden = false;
        if (done) done.hidden = true;
        if (send) { send.disabled = false; send.textContent = "Send my artwork"; }
        if (errBox) { errBox.hidden = true; errBox.textContent = ""; }

        fillBuild(dlg, readBuild(root));
        var when = $('input[name="contact[Show date]"]', dlg);
        if (when && dateIn) {
          if (dateIn.min) when.min = dateIn.min;
          if (dateIn.value && !when.value) when.value = dateIn.value;
        }
        if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", ""); }
        var first = $('input[name="contact[name]"]', dlg);
        if (first) window.setTimeout(function () { first.focus(); }, 80);
      });
    }

    function render() {
      listEl.innerHTML = "";
      picked.forEach(function (p) {
        var li = document.createElement("li");
        li.className = "mpq-file";
        li.dataset.state = p.big ? "big" : (p.url ? "up" : "new");
        li.innerHTML =
          '<span class="dot" aria-hidden="true"></span>' +
          '<span class="nm"></span>' +
          '<span class="sz">' + size(p.file.size) + "</span>" +
          '<button type="button" class="rm" aria-label="Remove">&times;</button>';
        li.querySelector(".nm").textContent = p.file.name;
        li.querySelector(".rm").addEventListener("click", function () {
          var at = picked.indexOf(p);
          if (at > -1) picked.splice(at, 1);
          render();
        });
        listEl.appendChild(li);
      });

      var big = picked.filter(function (p) { return p.big; });
      if (!bigBox) return;
      if (!big.length) { bigBox.hidden = true; return; }
      bigBox.textContent = (big.length === 1 ? "One file is" : big.length + " files are")
        + " too large to travel with this form. Leave it in the list — we will email you"
        + " an upload link for it, and the send still goes through now.";
      bigBox.hidden = false;
    }

    function take(files) {
      Array.prototype.forEach.call(files || [], function (f) {
        var dupe = picked.some(function (p) {
          return p.file.name === f.name && p.file.size === f.size;
        });
        if (!dupe) picked.push({ file: f, big: f.size > CEILING, url: "" });
      });
      render();
      if (errBox) errBox.hidden = true;
    }

    if (fileIn) {
      fileIn.addEventListener("change", function () {
        take(fileIn.files);
        fileIn.value = "";   /* so a removed file can be chosen again */
      });
    }

    if (drop) {
      ["dragenter", "dragover"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.add("over");
        });
      });
      ["dragleave", "dragend"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.remove("over");
        });
      });
      drop.addEventListener("drop", function (e) {
        e.preventDefault(); e.stopPropagation(); drop.classList.remove("over");
        take(e.dataTransfer && e.dataTransfer.files);
      });
    }

    /* Set once the files are lodged and the hidden fields are written. The
       handler runs twice: the first pass does our asynchronous work and
       stops the event, the second is let through to the browser. */
    var armed = false;

    aform.addEventListener("submit", function (e) {
      if (armed) {
        /* Everything below this line belongs to the browser and to Shopify's
           own captcha script. Stand aside. */
        return;
      }
      e.preventDefault();
      errBox.hidden = true; errBox.textContent = "";

      var nameIn  = $('input[name="contact[name]"]', aform);
      var emailIn = $('input[name="contact[email]"]', aform);
      var revert  = send.textContent;

      function fail(msg, el) {
        say("bad", msg);
        errBox.textContent = msg;
        errBox.hidden = false;
        send.disabled = false;
        send.textContent = revert || "Send my artwork";
        flag(el);
      }

      if (!nameIn.value.trim()) {
        fail("Tell us your name so we know whose artwork this is.", nameIn); return;
      }
      if (!emailIn.value.trim() || emailIn.value.indexOf("@") < 1) {
        fail("We need an email address to write back to.", emailIn); return;
      }
      if (!picked.length) {
        fail("Choose a file, or drop one on the panel above.", null); return;
      }

      /* The build is re-read at this moment, not at the moment it opened. */
      fillBuild(dlg, readBuild(root));

      send.disabled = true;
      say("busy", "Sending your artwork\u2026");
      var variantId = $("[data-variant-id]", root);
      var queue = picked.filter(function (p) { return !p.big && !p.url; });
      var step = 0;

      function next() {
        if (!variantId || step >= queue.length) return Promise.resolve();
        var p = queue[step];
        send.textContent = queue.length > 1
          ? ("Uploading " + (step + 1) + " of " + queue.length + "…")
          : "Uploading…";
        return uploadViaCart(variantId.value, p.file)
          .then(function (url) { p.url = url || ""; })
          .catch(function () { p.big = true; })
          .then(function () { step += 1; render(); return next(); });
      }

      next().then(function () {
        var urls = picked.filter(function (p) { return p.url; })
                         .map(function (p) { return p.file.name + " — " + p.url; });
        var later = picked.filter(function (p) { return p.big; })
                          .map(function (p) { return p.file.name + " (" + size(p.file.size) + ")"; });
        if (urlIn) urlIn.value = urls.length ? urls.join("\n") : "None attached";
        if (bigIn) bigIn.value = later.length ? ("Send an upload link for: " + later.join(", ")) : "";
        send.textContent = "Sending\u2026";

        /* The files are already in the shop's own files, so they travel with
           the cart line too, and only the message has to go over the wire. */
        handToSheet(root, picked.filter(function (p) { return !p.big; })
                                .map(function (p) { return p.file; }));
        try {
          var st = sheetState(root);
          st.email = emailIn.value.trim();
          st.n = picked.length;
          window.sessionStorage.setItem(STASH, JSON.stringify(st));
        } catch (err) {}

        say("busy", "Finishing your send \u2014 one moment\u2026");

        /* requestSubmit, never submit. submit() is the method and raises no
           event, so Shopify's captcha script never sees it and the post lands
           with no token. requestSubmit() raises the real thing. */

        /* If the buyer closes the challenge instead of answering it, no
           navigation happens and the button would sit disabled for ever. The
           page takes this timer with it when it leaves. */
        window.setTimeout(function () {
          send.disabled = false;
          send.textContent = revert || "Send my artwork";
          say("", "");
        }, 25000);

        armed = true;
        if (aform.requestSubmit) { aform.requestSubmit(); }
        else { armed = false; fail("That did not send. Email sales@megaprintery.com and we will pick it up from there."); }
      }).catch(function () {
        fail("That did not send. Email sales@megaprintery.com and we will pick it up from there.");
      });
    });
  }

  /* ------------------------------------------------- the way back ----- */
  /* Shopify sends the buyer back here with contact_posted=true. Put the
     sheet back the way they left it and tell them it went. */
  function settle() {
    if (window.location.search.indexOf("contact_posted=true") < 0) return;
    var raw = null;
    try { raw = window.sessionStorage.getItem(STASH); } catch (e) {}
    if (!raw) return;
    try { window.sessionStorage.removeItem(STASH); } catch (e) {}
    var st;
    try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st || st.path !== window.location.pathname) return;

    var root = $("[data-product-root]") || document;
    window.setTimeout(function () { restoreSheet(root, st); }, 60);
    markSent(root, st.email, st.n || 1, false);

    if (window.history && history.replaceState) {
      var sp = new URLSearchParams(window.location.search);
      sp.delete("contact_posted");
      sp.delete("form_type");
      var qs = sp.toString();
      history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : ""));
    }
  }

  function boot() { wire(); settle(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", wire);
})();
